import { DateTime } from 'luxon';

export const months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
export const numericInputRegex = /^[0-9]*$/g;
export const alphabetsDashInputRegex = /^[a-zA-Z- ]*$/g;
export const alphaNumCommaDotDashInputRegex = /^[A-Za-z0-9\s,\\.\\-]*$/g;
export const birthYearRegex = /(?:19|20)\d\d/g;
export const emailRegex = /^(([^<>()\\[\]\\.,;:\s@"]+(\.[^<>()\\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
export function preventWindowClose(e: BeforeUnloadEvent) {
	e.preventDefault();
}
export function isJsonString(str: string): boolean {
	try {
		JSON.parse(str);
		return true;
	} catch (e) {
		return false;
	}
}

export const portalAudience: 'student' | 'teacher' | 'admin' = import.meta.env.VITE_PORTAL_AUDIENCE;
export const isStudentApp = import.meta.env.VITE_PORTAL_AUDIENCE === 'student';
export const isTeacherApp = import.meta.env.VITE_PORTAL_AUDIENCE === 'teacher';
export const isAdminApp = import.meta.env.VITE_PORTAL_AUDIENCE === 'admin';

export const getReadableDate = (date: string | undefined) => {
	if (date) {
		return DateTime.fromISO(date, { zone: 'utc' }).toFormat('MM-dd-yyyy');
	}
	return '';
};

export const parseNumberSeries = (input: string | undefined): number[] => {
	if (input) {
		const segments = input.split(',');
		const result: number[] = [];
		for (const segment of segments) {
			if (segment.includes('-')) {
				const [start, end] = segment.split('-').map(Number);
				if (start <= end) {
					for (let i = start; i <= end; i++) {
						result.push(i);
					}
				} else {
					throw new Error(`Invalid range: ${segment}`);
				}
			} else {
				result.push(Number(segment));
			}
		}
		return result;
	}
	return [];
};

export const toggleClass = (pageRef: React.RefObject<HTMLDivElement>, className: string) => {
	if (pageRef.current) {
		pageRef.current.classList.toggle(className);
	}
};

export const addClass = (pageRef: React.RefObject<HTMLDivElement>, className: string) => {
	if (pageRef.current) {
		pageRef.current.classList.add(className);
	}
};

export const removeClass = (pageRef: React.RefObject<HTMLDivElement>, className: string) => {
	if (pageRef.current) {
		pageRef.current.classList.remove(className);
	}
};

export const containsClass = (pageRef: React.RefObject<HTMLDivElement>, className: string) => {
	if (pageRef.current) {
		return pageRef.current.classList.contains(className);
	}
	return false;
};

export function formatLastSavedDate(lastSavedDate: Date | null | undefined): string | null {
	if (!lastSavedDate) { return null; }

	const currentDate = new Date();

	const isSameDay =
		lastSavedDate.getFullYear() === currentDate.getFullYear() &&
		lastSavedDate.getMonth() === currentDate.getMonth() &&
		lastSavedDate.getDate() === currentDate.getDate();

	const pad = (n: number) => n.toString().padStart(2, '0');

	if (isSameDay) {
		return lastSavedDate.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
	}

	const mm = pad(lastSavedDate.getMonth() + 1); // Months are 0-indexed
	const dd = pad(lastSavedDate.getDate());
	const yyyy = lastSavedDate.getFullYear();
	const time = lastSavedDate.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });

	return `${mm}/${dd}/${yyyy} ${time}`;
}


